/* SHEEP Device — order check + Member SHEEP auto-save. Moved out of snippets/sheep-device-check.liquid on 1 Nov 2026
   (SPEED, Microsoft Clarity): the code is now a cached file. Page/customer values come from window.__SDC, written by the snippet.
   Must load BEFORE assets/sheep-my-device.js (it seeds the device cookie first). Both "defer", same order as in head.is-land.
   Backup of the inline version: snippets/zz-backup-sheep-device-check-before-asset-2026-11-01.liquid */
(function(){
  var CFG = window.__SDC || {};
  var KEY = 'sheep_my_device', TKEY = 'sheep_my_device_t';
  var SYNC = 'https://sheep-device-sync.netlify.app/api/device';
  var LOGGED = !!CFG.logged;
  var CID = CFG.cid || null;
  var SIG = CFG.sig || null;
  var ACC = CFG.acc || null;
  var LOGIN = CFG.login || '/account/login';
  var PT = CFG.pt || '';
  var DESIGN = !!CFG.design;
  var PRODUCT = CFG.product || null;

  function getCookie(k){ var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + k + '=([^;]+)')); return m ? m[1] : null; }
  function setCookie(k, v, age){ document.cookie = k + '=' + v + '; path=/; max-age=' + age + '; SameSite=Lax'; }
  function readLocal(){ var r = getCookie(KEY); if (!r) return null; try { var o = JSON.parse(decodeURIComponent(r)); if (Array.isArray(o)) return o; if (o && typeof o === 'object') return Object.keys(o).map(function(k){ return o[k]; }); } catch(e){} return null; }
  function writeLocal(list, t){
    if (list && list.length) { setCookie(KEY, encodeURIComponent(JSON.stringify(list)), 31536000); setCookie(TKEY, String(t || Date.now()), 31536000); }
    else { setCookie(KEY, '', 0); setCookie(TKEY, String(t || Date.now()), 31536000); }
  }
  function same(a, b){ return JSON.stringify((a || []).slice().sort()) === JSON.stringify((b || []).slice().sort()); }

  /* 3) Member SHEEP ↔ browser: decide which list is newer (runs before sheep-my-device reads the cookie) */
  var accD = Array.isArray(ACC) ? ACC : (ACC && Array.isArray(ACC.d) ? ACC.d : null);
  var accT = (ACC && !Array.isArray(ACC) && Number(ACC.t)) || 0;
  var localD = readLocal(), localT = Number(getCookie(TKEY)) || 0;
  var seeded = '', pushOnLoad = false;
  if (LOGGED) {
    if (accD && accD.length && !localD) { writeLocal(accD, accT || Date.now()); seeded = 'load'; }
    else if (accD && localD && !same(localD, accD) && accT > localT) { writeLocal(accD, accT); seeded = 'update'; }
    else if (localD && (!accD || (!same(localD, accD) && localT >= accT))) { pushOnLoad = true; }
  }

  function push(list, t){
    if (!LOGGED || !SIG || !CID) return Promise.resolve(false);
    return fetch(SYNC, { method:'POST', headers:{ 'Content-Type':'application/json' }, keepalive:true,
      body: JSON.stringify({ cid: String(CID), sig: SIG, devices: list || [], t: t || Date.now() }) })
      .then(function(r){ return r.ok ? r.json() : { ok:false }; })
      .then(function(j){ return !!(j && j.ok); })
      .catch(function(){ return false; });
  }
  function savedNote(){
    var t = document.querySelector('.smd-toast');
    if (t && t.textContent.indexOf('Member SHEEP') < 0) { t.textContent += ' · บันทึกลงบัญชี Member SHEEP แล้ว ✓'; return; }
    toast('บันทึก SHEEP Device ลงบัญชี Member SHEEP แล้ว ✓');
  }
  /* every save in the SHEEP Device picker → stamp time + auto-save to the account */
  document.addEventListener('click', function(e){
    if (!e.target.closest || !e.target.closest('.smd-pick .smd-save')) return;
    setTimeout(function(){
      var list = readLocal() || [], t = Date.now();
      setCookie(TKEY, String(t), 31536000);
      push(list, t).then(function(ok){ if (ok) savedNote(); });
    }, 120);
  }, true);

  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]; }); }
  function SMD(){ return window.SheepMyDevice || null; }
  function mine(){ var s = SMD(); return s ? s.get() : []; }
  function lineOf(s){
    s = String(s || '').toLowerCase().trim();
    if (s.indexOf('iphone') === 0) return 'iphone';
    if (s.indexOf('samsung') === 0 || s.indexOf('galaxy') === 0) return 'samsung';
    if (s.indexOf('oppo') === 0) return 'oppo';
    if (s.indexOf('ipad') === 0) return 'ipad';
    if (s.indexOf('airpods') === 0) return 'airpods';
    if (s.indexOf('macbook') === 0) return 'macbook';
    if (s.indexOf('apple pencil') === 0 || s.indexOf('pencil') === 0) return 'pencil';
    return null;
  }
  var CAT = { iphone:'phone', samsung:'phone', oppo:'phone', ipad:'ipad', airpods:'airpods', macbook:'macbook', pencil:'pencil' };
  var CATN = { phone:'มือถือ', ipad:'iPad', airpods:'AirPods', macbook:'MacBook', pencil:'Apple Pencil' };
  var OPTN = ['รุ่น', 'model', 'รุ่นมือถือ', 'device'];
  function modelValue(opts){
    for (var i = 0; i < (opts || []).length; i++) {
      var n = String(opts[i].name || '').toLowerCase().trim();
      if (OPTN.indexOf(n) > -1) return opts[i].value;
    }
    return null;
  }
  /* status of one item: ok / bad / nodev (category not saved) / na (no model option) */
  function status(v){
    if (!v) return { s:'na' };
    var l = lineOf(v), c = CAT[l];
    if (!c) return { s:'na' };
    var same = mine().filter(function(m){ return CAT[lineOf(m)] === c; });
    if (!same.length) return { s:'nodev', cat:c };
    var fit = same.filter(function(m){ return SMD().fits(m, v); });
    return fit.length ? { s:'ok', fit:fit } : { s:'bad', mine:same, cat:c };
  }
  function marks(a){ return '<mark class="smd-mk smd-mk--static">' + a.map(esc).join('</mark>, <mark class="smd-mk smd-mk--static">') + '</mark>'; }

  var cart = null, loading = null;
  function loadCart(){
    if (loading) return loading;
    loading = fetch('/cart.js', { headers:{ Accept:'application/json' } }).then(function(r){ return r.json(); }).then(function(c){ cart = c; loading = null; return c; }).catch(function(){ loading = null; return cart; });
    return loading;
  }
  function checkCart(c){
    var out = [];
    (c && c.items || []).forEach(function(it){
      var v = modelValue(it.options_with_values);
      out.push({ item: it, v: v, st: status(v) });
    });
    return out;
  }

  /* ---------- per-item badges in cart page + drawer ---------- */
  function badgeHTML(r){
    var st = r.st;
    if (st.s === 'ok') return '<span class="sdc-b__i">✓</span><span>ตรงกับ ' + marks(st.fit) + ' ของคุณ</span>';
    if (st.s === 'bad') return '<span class="sdc-b__i">!</span><span>ไม่ตรงกับ SHEEP Device ของคุณ (' + st.mine.map(esc).join(', ') + ')</span>';
    if (st.s === 'nodev' && mine().length) return '<span class="sdc-b__i">?</span><span>ยังไม่ได้บันทึก' + esc(CATN[st.cat]) + ' · <a href="#" data-smd-open="' + st.cat + '">เพิ่มใน SHEEP Device</a></span>';
    return '';
  }
  function paint(){
    var rows = document.querySelectorAll('.cart__item[data-key]');
    if (!rows.length || !cart) return;
    var res = checkCart(cart), byKey = {};
    res.forEach(function(r){ byKey[r.item.key] = r; });
    rows.forEach(function(row){
      var r = byKey[row.getAttribute('data-key')], old = row.querySelector('.sdc-b');
      var html = r ? badgeHTML(r) : '';
      var cls = r ? 'sdc-b is-' + r.st.s : 'sdc-b';
      if (old && old.getAttribute('data-h') === cls + html) return;
      if (old) old.remove();
      if (!html) return;
      var b = document.createElement('div'); b.className = cls; b.setAttribute('data-h', cls + html); b.innerHTML = html;
      var t = row.querySelector('.cart__item-title') || row.querySelector('.cart__item-details') || row;
      t.appendChild(b);
    });
    var nOk = res.filter(function(r){ return r.st.s === 'ok'; }).length, nBad = res.filter(function(r){ return r.st.s === 'bad'; }).length;
    document.querySelectorAll('.cart__checkout').forEach(function(btn){
      var box = btn.parentNode, s = box.querySelector('.sdc-sum');
      var html = '';
      if (mine().length && (nOk || nBad)) html = nBad ? '<span class="sdc-sum__i is-bad">!</span> มี ' + nBad + ' ชิ้นที่ไม่ตรงกับ SHEEP Device ของคุณ' : '<span class="sdc-sum__i">✓</span> ตรวจกับ SHEEP Device แล้ว ตรงทุกชิ้น';
      else if (!mine().length && res.some(function(r){ return r.st.s === 'nodev'; })) html = '<span class="sdc-sum__i is-ask">?</span> <a href="#" data-smd-open>ตั้งค่า SHEEP Device</a> แล้วเราจะเช็ครุ่นให้ก่อนสั่ง';
      if (s && s.getAttribute('data-h') === html) return;
      if (s) s.remove();
      if (!html) return;
      var d = document.createElement('div'); d.className = 'sdc-sum' + (nBad ? ' is-bad' : ''); d.setAttribute('data-h', html); d.innerHTML = html;
      box.insertBefore(d, btn);
    });
  }

  /* ---------- cart attributes for the team ---------- */
  function attrs(res, confirmed){
    var m = mine();
    if (!m.length) return null;
    var bad = res.filter(function(r){ return r.st.s === 'bad'; });
    var check = bad.length
      ? (confirmed ? 'ลูกค้ายืนยันสั่งแม้ไม่ตรง: ' : 'ไม่ตรง: ') + bad.map(function(r){ return r.item.product_title + ' (' + r.v + ')'; }).join(' | ')
      : (res.some(function(r){ return r.st.s === 'ok'; }) ? 'ตรงทุกชิ้น' : 'ไม่มีสินค้าที่ต้องเช็ครุ่น');
    return { 'SHEEP Device': m.join(', '), 'SHEEP Device ตรวจรุ่น': check, '_sheep_device_json': JSON.stringify(m) };
  }
  function saveAttrs(a){
    if (!a) return Promise.resolve();
    return fetch('/cart/update.js', { method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' }, body: JSON.stringify({ attributes: a }) }).catch(function(){});
  }

  /* ---------- sheet (modal) ---------- */
  function closeSheet(){ var o = document.querySelector('.sdc-pop'); if (o) o.remove(); document.documentElement.classList.remove('smd-lock'); }
  function rowHTML(r){
    var it = r.item, img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
    var st = r.st, tag = '';
    if (st.s === 'ok') tag = '<span class="sdc-t is-ok">✓ ตรงกับ ' + st.fit.map(esc).join(', ') + '</span>';
    else if (st.s === 'bad') tag = '<span class="sdc-t is-bad">! ไม่ตรงกับ ' + st.mine.map(esc).join(', ') + '</span>';
    else if (st.s === 'nodev') tag = '<span class="sdc-t">ยังไม่ได้บันทึก' + esc(CATN[st.cat]) + '</span>';
    return '<li class="sdc-r is-' + st.s + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<span class="sdc-r__ph"></span>') +
      '<span class="sdc-r__b"><span class="sdc-r__n">' + esc(it.product_title) + '</span>' + (r.v ? '<span class="sdc-r__v">' + esc(r.v) + (it.quantity > 1 ? ' × ' + it.quantity : '') + '</span>' : '') + tag + '</span></li>';
  }
  function sheet(res, onGo, opts){
    closeSheet();
    opts = opts || {};
    var bad = res.filter(function(r){ return r.st.s === 'bad'; });
    var shown = res.filter(function(r){ return r.st.s !== 'na'; });
    var o = document.createElement('div');
    o.className = 'sdc-pop' + (bad.length ? ' is-bad' : ' is-ok'); o.setAttribute('role', 'dialog'); o.setAttribute('aria-modal', 'true'); o.setAttribute('aria-labelledby', 'sdcTitle');
    var head = bad.length
      ? '<p class="sdc-eyebrow">SHEEP DEVICE</p><h2 class="sdc-title" id="sdcTitle">มี ' + bad.length + ' ชิ้นที่รุ่นไม่ตรงกับ SHEEP Device ของคุณ</h2><p class="sdc-sub">ตรวจอีกครั้งก่อนสั่ง จะได้ไม่ต้องเสียเวลาส่งคืน · ถ้าตั้งใจซื้อรุ่นนี้ (เช่น เป็นของขวัญ) กดยืนยันได้เลย</p>'
      : '<p class="sdc-eyebrow">SHEEP DEVICE</p><h2 class="sdc-title" id="sdcTitle"><span class="sdc-ok">✓</span> ตรงกับ SHEEP Device ของคุณทุกชิ้น</h2><p class="sdc-sub">กำลังไปหน้าชำระเงิน…</p>';
    var btns = bad.length
      ? '<div class="sdc-actions"><button type="button" class="sdc-back is-main">กลับไปแก้ไข</button><button type="button" class="sdc-go">ยืนยันสั่งซื้อ</button></div>'
      : '<div class="sdc-actions"><button type="button" class="sdc-go is-main">ไปชำระเงิน</button></div><div class="sdc-bar"><i></i></div>';
    o.innerHTML = '<div class="sdc-box"><button type="button" class="sdc-x" aria-label="ปิด">&times;</button>' + head + '<ul class="sdc-list">' + shown.map(rowHTML).join('') + '</ul>' + btns + '</div>';
    document.body.appendChild(o);
    document.documentElement.classList.add('smd-lock');
    var done = false, timer = null;
    function go(){ if (done) return; done = true; clearTimeout(timer); var g = o.querySelector('.sdc-go'); if (g) { g.disabled = true; g.textContent = 'กำลังไปต่อ…'; } onGo(bad.length > 0); }
    o.addEventListener('click', function(e){
      if (e.target === o || e.target.closest('.sdc-x') || e.target.closest('.sdc-back')) { clearTimeout(timer); closeSheet(); if (opts.onBack) opts.onBack(); return; }
      if (e.target.closest('.sdc-go')) go();
    });
    document.addEventListener('keydown', function k(e){ if (e.key === 'Escape') { clearTimeout(timer); closeSheet(); document.removeEventListener('keydown', k); } });
    if (!bad.length) timer = setTimeout(go, 1600);
    var f = o.querySelector('.sdc-actions .is-main'); if (f) f.focus({ preventScroll: true });
  }

  /* ---------- 1) intercept "ชำระเงิน" in cart page + drawer ---------- */
  var pass = false;
  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('.cart__checkout, form[action$="/cart"] [name="checkout"]');
    if (!btn || pass || DESIGN || !SMD()) return;
    var form = btn.form || btn.closest('form');
    if (!form) return;
    if (!mine().length) return;
    if (form.querySelector('[name="terms"]') && !form.querySelector('[name="terms"]').checked) return;
    e.preventDefault(); e.stopImmediatePropagation();
    loadCart().then(function(c){
      var res = checkCart(c);
      function submit(confirmed){
        saveAttrs(attrs(res, confirmed)).then(function(){
          pass = true;
          var h = document.createElement('input'); h.type = 'hidden'; h.name = 'checkout'; h.value = '1'; form.appendChild(h);
          HTMLFormElement.prototype.submit.call(form);
        });
      }
      if (!res.some(function(r){ return r.st.s === 'ok' || r.st.s === 'bad'; })) { submit(false); return; }
      sheet(res, submit);
    });
  }, true);

  /* ---------- product page "Buy it now" ---------- */
  var pjson = null;
  if (PT === 'product' && PRODUCT) {
    fetch('/products/' + PRODUCT + '.js').then(function(r){ return r.json(); }).then(function(p){ pjson = p; }).catch(function(){});
  }
  function selectedVariant(){
    if (!pjson) return null;
    var f = document.querySelector('#MainContent form[action*="/cart/add"] [name="id"]');
    var id = f ? Number(f.value) : null;
    return pjson.variants.filter(function(v){ return v.id === id; })[0] || null;
  }
  document.addEventListener('click', function(e){
    if (PT !== 'product' || pass || DESIGN || !SMD() || !mine().length) return;
    var b = e.target.closest && e.target.closest('shopify-buy-it-now-button, .shopify-payment-button, [data-shopify="payment-button"]');
    if (!b) return;
    var v = selectedVariant();
    if (!v) return;
    var opts = (pjson.options || []).map(function(o, i){ return { name: (o && o.name) || o, value: v.options[i] }; });
    var mv = modelValue(opts), st = status(mv);
    if (st.s !== 'bad') return;
    e.preventDefault(); e.stopImmediatePropagation();
    var q = document.querySelector('#MainContent form[action*="/cart/add"] [name="quantity"]');
    var qty = Math.max(1, parseInt(q && q.value, 10) || 1);
    var res = [{ item: { product_title: pjson.title, image: (v.featured_image && v.featured_image.src) || pjson.featured_image, quantity: qty, key: 'x' }, v: mv, st: st }];
    sheet(res, function(){
      var a = attrs(res, true), qs = [];
      Object.keys(a).forEach(function(k){ qs.push('attributes[' + encodeURIComponent(k) + ']=' + encodeURIComponent(a[k])); });
      location.href = '/cart/' + v.id + ':' + qty + '?' + qs.join('&');
    });
  }, true);

  /* keep badges + team attributes current on cart page / drawer */
  var lastAttr = '';
  function refresh(){
    if (!SMD() || !document.querySelector('.cart__item[data-key]')) return;
    loadCart().then(function(c){
      paint();
      var a = attrs(checkCart(c), false), s = JSON.stringify(a);
      if (a && s !== lastAttr && c && c.item_count) {
        var cur = c.attributes || {};
        lastAttr = s;
        if (cur['_sheep_device_json'] !== a['_sheep_device_json'] || (cur['SHEEP Device ตรวจรุ่น'] || '').indexOf('ลูกค้ายืนยัน') < 0 && cur['SHEEP Device ตรวจรุ่น'] !== a['SHEEP Device ตรวจรุ่น']) saveAttrs(a);
      }
    });
  }
  document.addEventListener('cart:updated', function(){ cart = null; refresh(); });

  /* picker: Member SHEEP line */
  function tunePicker(){
    var p = document.querySelector('.smd-pick');
    if (!p || p.getAttribute('data-sdc')) return;
    p.setAttribute('data-sdc', '1');
    var sub = p.querySelector('.smd-sub'); if (!sub) return;
    var n = document.createElement('p'); n.className = 'sdc-acc';
    n.innerHTML = (LOGGED && SIG)
      ? '<span class="sdc-acc__i">✓</span> เชื่อมกับบัญชี Member SHEEP แล้ว · บันทึกอัตโนมัติทุกครั้ง ใช้ได้ทุกเครื่อง'
      : '<span class="sdc-acc__i">✦</span> <a href="' + esc(LOGIN) + '">เข้าสู่ระบบ Member SHEEP</a> แล้ว SHEEP Device จะบันทึกลงบัญชีอัตโนมัติ ใช้ได้ทุกเครื่อง';
    sub.parentNode.insertBefore(n, sub.nextSibling);
  }
  function toast(msg){
    var t = document.createElement('div'); t.className = 'smd-toast'; t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function(){ t.classList.add('is-out'); }, 2600);
    setTimeout(function(){ t.remove(); }, 3100);
  }

  function ready(){
    if (seeded === 'load') toast('โหลด SHEEP Device จากบัญชี Member SHEEP แล้ว');
    else if (seeded === 'update') toast('อัปเดต SHEEP Device ตามบัญชี Member SHEEP แล้ว');
    if (pushOnLoad) { var l = readLocal() || []; push(l, Number(getCookie(TKEY)) || Date.now()).then(function(ok){ if (ok && !getCookie(TKEY)) setCookie(TKEY, String(Date.now()), 31536000); }); }
    refresh();
    var t, lastRows = '';
    new MutationObserver(function(){
      tunePicker();
      clearTimeout(t);
      t = setTimeout(function(){
        var keys = [].map.call(document.querySelectorAll('.cart__item[data-key]'), function(r){ var q = r.querySelector('.js-qty__num'); return r.getAttribute('data-key') + ':' + (q ? q.value : ''); }).join(',');
        var sig = keys + '|' + JSON.stringify(mine());
        if (sig !== lastRows) { lastRows = sig; cart = null; refresh(); }
        else paint();
      }, 250);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
})();
